import { motion } from "framer-motion";
import { useState, useRef } from "react";
import FileDialog from "./FileViewer";

export default function RecentWorkFlip({works}) {
  const [activeIndex, setActiveIndex] = useState(null);
  const [selectedFile, setSelectedFile] = useState(null);

  const handleToggle = (index) => {
    const isMobile = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
    if (isMobile) {
      setActiveIndex(activeIndex === index ? null : index);
    }
  };

  const hoverTimeout = useRef(null); // To track the delay

  const handleHoverStart = (index, file) => {
    setActiveIndex(index);
    
    // Start a timer: If they stay for 600ms, open the dialog
    hoverTimeout.current = setTimeout(() => {
      setSelectedFile(file);
    }, 2000); 
  };

  const handleHoverEnd = () => {
    setActiveIndex(null);
    // If they move the mouse away before 600ms, cancel the opening
    if (hoverTimeout.current) {
      clearTimeout(hoverTimeout.current);
    }
  };

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 px-4 py-10 justify-items-center">
      {works.map((w, i) => (
        <motion.div
          key={i}
          className="w-full max-w-[250px] sm:max-w-[280px] md:max-w-[300px] aspect-[3/4] cursor-pointer"
          style={{ perspective: 1000 }}
          onHoverStart={() => handleHoverStart(i, w)}
          onHoverEnd={handleHoverEnd}
          onClick={() => handleToggle(i)}
        >
          <motion.div
            className="relative w-full h-full rounded-lg shadow-lg"
            animate={{ rotateY: activeIndex === i ? 180 : 0 }}
            transition={{ duration: 0.6, ease: "easeInOut" }}
            style={{ transformStyle: "preserve-3d" }}
          >
            {/* Front Side */}
            <div
              className="absolute z-10 w-full h-full rounded-lg flex items-center justify-center bg-gray-200 overflow-hidden"
              style={{ backfaceVisibility: "hidden" }}
            >
              <img
                src={w.src} // Suggestion: Use a thumbnail image for the front
                className="w-full h-full object-cover filter blur-sm scale-105"
                alt=""
              />
              <div className="absolute inset-0 bg-black/40 flex flex-col items-center justify-center p-4">
                <h3 className="text-white text-xl sm:text-2xl font-cinzel tracking-wide text-center">
                  {w.type}
                </h3> 
              </div>
            </div>

            {/* Back Side (The File) */}
            <div 
              className="absolute inset-0 w-full h-full rounded-lg bg-white flex flex-col items-center justify-center p-6"
              style={{ backfaceVisibility: "hidden", transform: "rotateY(180deg)" }}
            >
              <button
                onClick={() => setSelectedFile(w)} // Opens the modal
                className="bg-black text-white px-8 py-3 rounded-full hover:scale-105 transition-transform"
              >
                View 
              </button>
            </div>
          </motion.div>
        </motion.div>
      ))}
    <FileDialog 
        isOpen={!!selectedFile} 
        onClose={() => setSelectedFile(null)} 
        file={selectedFile} 
      />
    </div>
  );
}